/** State of validation in a UI form. Patternfly-compatible. */
export type FormValidationState = { validated: 'default' | 'success' | 'warning' | 'error', helperTextInvalid: string | null };

/** Default empty validation. */
export const defaultValidation: FormValidationState = { validated: 'default', helperTextInvalid: null };
